import { css } from "styled-components";

export const checkboxInputCss = css`
  ${({
    disabled,
    theme: {
      colors: { grey, lightGrey, lighterGrey, offWhite, white },
    },
  }) => `
    position: absolute;
    display: block;
    height: 1px;
    width: 1px;
    word-break: normal !important;
    overflow: hidden;
    z-index: -1;

    + div {
      background-color: ${white};
      border: 2px solid ${lighterGrey};
      border-radius: 3px;
      height: 22px;
      width: 22px;
    }

    ${
      disabled
        ? `
        + div {
          background-color: ${lighterGrey};
          opacity: 0.8;
        }
      `
        : `
      :active + div, :focus + div {
        border: 1px solid ${grey};
      }
      :checked + div {
        border: 1px solid ${grey};
        background-color: ${grey};
        transition: border 150ms ease-in;
      }
      :checked + div::before {
        border-bottom: 3px solid ${offWhite};
        border-right: 3px solid ${offWhite};
        content: "";
        display: block;
        height: 12px;
        margin: 0 auto;
        transform: rotate(40deg) translateX(1px) translateY(1px);
        width: 5px;
      }
    `
    }
  `}
`;
